import type { ComponentType } from 'react';

/** @internal */
export type GetWidget = <P extends {}>(
  widgetId: string,
  options?: { skeletonClassName?: string },
) => ComponentType<P>;

export type GetWidgetAsync = <P extends {}>(
  widgetId: string,
) => Promise<ComponentType<P>>;
